var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 37,
    viewBox: "0 0 181 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m54.056 28.88-8.158-17.915h3.753l5.716 12.95 5.45-12.95h3.27l-7.76 17.916h-2.271zM69.676 15.2c0-1.628.241-2.742.722-3.34.48-.6 1.406-.898 2.779-.898h10.39c1.37 0 2.296.298 2.779.897.48.6.722 1.713.722 3.34v9.441c0 1.639-.242 2.755-.722 3.349-.48.593-1.406.889-2.78.889h-10.39c-1.37 0-2.295-.296-2.778-.89-.48-.593-.722-1.709-.722-3.348V15.2zm3.284 10.305h10.832v-11.34H72.96v11.34zM96.031 28.88V10.963h3.284v14.543h10.591v3.373H96.031v.003zM116.301 28.88l7.984-17.915h3.165l8.093 17.916h-3.685l-1.697-3.915h-8.948l-1.642 3.915h-3.273.003zm6.315-7.153h6.183l-3.045-7.288-3.138 7.288zM142.136 28.88V10.963h12.072c1.121 0 1.935.274 2.437.82.502.548.755 1.434.755 2.654v4.205c0 1.21-.253 2.09-.755 2.645-.502.553-1.316.832-2.437.832h-1.843l6.517 6.763h-4.715l-5.688-6.763h-3.111v6.763h-3.232zm10.617-14.813h-7.385v4.984h7.385c.57 0 .961-.104 1.17-.314.209-.208.315-.58.315-1.111v-2.153c0-.52-.106-.884-.315-1.094-.209-.208-.6-.315-1.17-.315v.003zM166.114 28.88V10.963h14.45v3.05h-11.163v4h6.516v3.05h-6.516v4.44H180.7v3.373h-14.583l-.003.006z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.07 14.064 9.447 28.596l21.968-25.11-14.347 10.578z",
    fill: "url(#iti85763ma)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.874 0 0 11.233l13.562 8.546L2.874 0z",
    fill: "url(#um8s7iaedb)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.416 3.485 9.448 28.596 14.021 37 31.416 3.485z",
    fill: "url(#1puhv6xpec)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.562 19.779 0 11.233l9.138 16.791 4.424-8.245z",
    fill: "url(#yom4d237fd)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "iti85763ma",
    x1: 7.676,
    y1: 27.565,
    x2: 30.906,
    y2: 2.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#951E23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#C62731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E72E3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "um8s7iaedb",
    x1: 14.355,
    y1: 21.163,
    x2: -1.668,
    y2: 2.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#422188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#4E207D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#A21A39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3181F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1puhv6xpec",
    x1: 10.206,
    y1: 34.423,
    x2: 35.569,
    y2: 6.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB3115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E35813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA7912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yom4d237fd",
    x1: 0.429,
    y1: 24.353,
    x2: 24.873,
    y2: -3.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF341A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#D7551A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0761A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.29f34e5bdcde57987a531696bca7b5d4.svg";
export { ForwardRef as ReactComponent };